import './js/header';
import './js/slick.min';

import './js/favorites/favorite_filter';
import './js/favorites/favorite_recipes';

import './js/modals/mobile_menu';
import './js/modals/order_now';
import './js/modals/rating';
import './js/modals/recipe';
import './js/modals/scroll-up';

import './js/api';
